import type { FC } from 'react'
import type { PageNotFoundProps } from '.'
import s from './page-not-found.module.css'

const PageNotFound: FC<PageNotFoundProps> = () => {
  return (
    <div className={s.root}>
      <h1 className={s.title}>404</h1>
      <p>Essa página não existe.</p>
    </div>
  )
}

export default PageNotFound
